export default __webpack_public_path__ + "static/media/pdf.3747e759.svg";